import { render, staticRenderFns } from "./purchaseCompleted.vue?vue&type=template&id=36afe238&scoped=true"
import script from "./purchaseCompleted.vue?vue&type=script&lang=js"
export * from "./purchaseCompleted.vue?vue&type=script&lang=js"
import style0 from "./purchaseCompleted.vue?vue&type=style&index=0&id=36afe238&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36afe238",
  null
  
)

export default component.exports